import React from "react";
import moment from "moment";
import cns from "classnames";
import { isEmpty } from "lodash";
import { Card, makeStyles, Paper, Typography } from "@material-ui/core";
import { Link, Person, Visibility } from "@material-ui/icons";
import { AvatarGroup } from "@material-ui/lab";
import { TicketItemDataFragment } from "@graphql";
import locale from "@bonliva-crm/locale";
import { Subheading } from "@components";
import { ThemeType } from "@theme";
import { NodeRefList } from "@containers/NodeRefList/NodeRefList";
import UserAvatar from "@containers/UserAvatar";

type Props = {
  ticket: TicketItemDataFragment;
};

export function TicketCard(props: Props) {
  const { ticket } = props;
  const classes = useStyles({});

  return (
    <div className="hl">
      <Paper className={classes.card}>
        <div>
          <div>
            <Typography variant="h5" gutterBottom className={classes.title}>
              {ticket.Description}{" "}
              {ticket.ViewMode ? `(${locale.ticketsCard.viewOnly})` : null}
            </Typography>
          </div>
          <div className={classes.section}>
            <span>{locale.ticketsCard.assignedOn}: </span>
            {moment.utc(ticket.AssignedOn).format("YYYY-MM-DD")}
          </div>

          {ticket.Due && (
            <div className={classes.section}>
              <div className={classes.deadline}>
                <span>Deadline: {moment.utc(ticket.Due).format("YYYY-MM-DD")}</span>
              </div>
            </div>
          )}

          <div className={cns(classes.section, classes.personSection)}>
            <Person className={cns(classes.personIcon, classes.icon)} />
            {`${locale.ticketsProfile.assignedTo}: `}
            {ticket.AssignedTo ? ticket.AssignedTo.Name : ticket.AssignedTeam}
          </div>

          <div className={cns(classes.section, classes.personSection)}>
            <Person className={cns(classes.personIcon, classes.icon)} />
            {`${locale.ticketsProfile.customer}: `}
            {ticket.AssignedBy.Name}
          </div>

          {!isEmpty(ticket.LinkedItems) && (
            <div className={cns(classes.section, classes.personSection)}>
              <Link className={cns(classes.personIcon, classes.icon)} />
              {locale.Linked}:&nbsp;
              <NodeRefList items={ticket.LinkedItems} />
            </div>
          )}

          {!isEmpty(ticket.WhoWatched) && (
            <div className={cns(classes.section, classes.personSection)}>
              <Visibility className={cns(classes.personIcon, classes.icon)} />
              {/*{locale.Linked}:&nbsp;*/}
              <AvatarGroup>
                {ticket.WhoWatched.map((userRef, index) => (
                  <UserAvatar
                    key={index}
                    userName={userRef.Name}
                    size="small"
                    style={{
                      marginLeft: index === 0 ? "0" : "-8px",
                      border: "1px solid #fff",
                      boxSizing: "content-box"
                    }}
                  />
                ))}
              </AvatarGroup>
            </div>
          )}
        </div>
      </Paper>

      {ticket.SecondaryText && (
        <>
          <Subheading style={{ marginTop: "10px" }}>Info</Subheading>
          <Card className={classes.card}>
            <div>{ticket.SecondaryText}</div>
          </Card>
        </>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  card: {
    position: "relative",
    padding: "16px !important",
    whiteSpace: "pre-wrap"
  },

  title: {
    // wordBreak: "break-all",
    width: "90%"
  },

  section: {
    marginBottom: 8,
    "&:last-child": { marginBottom: 0 }
  },

  deadline: {
    display: "inline-block",
    padding: "5px 10px",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 16,
    color: theme.palette.primary.main
  },

  personSection: {
    display: "flex",
    alignItems: "center"
  },

  personIcon: {
    marginRight: 4
  },

  icon: {
    color: "#616161"
  }
}));
